import * as React from 'react';
import { forwardRef } from 'react';
const LabelPairedChevronLeftSmRegularIcon = ({ title, titleId, ...props }, ref) => (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: 9, height: 22, viewBox: '0 0 9 22', role: 'img', ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", null,
        React.createElement("path", { d: 'M.672 11.078a.463.463 0 0 1 0-.629l5.25-5.25a.463.463 0 0 1 .629 0 .463.463 0 0 1 0 .63L1.6 10.75l4.95 4.95a.463.463 0 0 1 0 .628.463.463 0 0 1-.63 0z' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: '72954560554ccc028ce578ead3368d04__a' },
            React.createElement("path", { d: 'M0 0h9v22H0z' })))));
const ForwardRef = forwardRef(LabelPairedChevronLeftSmRegularIcon);
export default ForwardRef;
